















































































































































































































































































































































import { Component, Prop, Ref, Vue, Watch } from 'vue-property-decorator'
import SeletorDeCliente from '../clientes/SeletorDeCliente.vue';
import SeletorDeLojasDoUsuario from '@/components/loja/SeletorDeLojasDoUsuario.vue';
import { obrigatorio } from '@/shareds/regras-de-form';
import { FormaDePagamento, PontoDeVendaComTurno, Titulo, Usuario, ValorSomaTitulo } from '@/models';
import { dateToPtBrFormat } from '@/shareds/date/date-utils';
import { FindTituloUseCase } from '@/usecases/titulos/FindTituloUseCase';
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore';
import { FormDeFiltroDeTitulos } from './NovaTelaDeTitulos.vue';
import DataTableDeCrudPaginado from '@/components/ui/DataTableDeCrudPaginado.vue';
import AlertModule from '@/store/vuex/aplicacao/AlertModule';
import CheckboxButton from '@/components/ui/CheckboxButton.vue';
import { CreateBaixaDePagamentoUseCase, FindBaixaDePagamentoUseCase } from '@/usecases';
import { BaixaDePagamentoMultiploForm, TipoDeTransacaoDaBaixaDePagamento } from '@/models/financeiro/BaixaDePagamento';
import moment from 'moment';
import { imprimirComprovanteDeRecebivel } from "@/shareds/venda-shareds"
import CampoDecimal from '@/components/ui/CampoDecimal.vue';
import { formatarMoeda } from '@/shareds/formatadores';
import { DataOptions } from 'vuetify';
import { FindPdvUseCase } from '@/usecases/pdv/FindPdvUseCase';
import Decimal from 'decimal.js';
import { calcularDataAposCarencia } from '@/shareds/titulo-shareds';
import DatePicker from '@/components/ui/DatePicker.vue';
import SeletorDeAdquirente from '@/views/application/venda/SeletorDeAdquirente.vue'

const FILTRO_DE_TITULOS = 'FILTRO_DE_TITULOS'

	@Component({
		components: {
			SeletorDeCliente,
			SeletorDeLojasDoUsuario,
			DataTableDeCrudPaginado,
			CheckboxButton,
			CampoDecimal,
			DatePicker,
			SeletorDeAdquirente,
		},
	})
export default class DialogoDePagamentoEmMassaDeTitulos extends Vue {
	@Prop({ type: Boolean, default: false }) carregando!: boolean
	@Ref() menu!: {
		save: (value?: any) => void
	}
	@Ref() form!: HTMLFormElement

	mostra: boolean | null = null
	lojaId: string | null = null
	usuario: Usuario | null = null
	valor: number | null = null
	formattedValue: number | null = null
	valorAtualizado = null
	formaDePagamento = ''
	formaDePagamamentoParaPagar = null
	titulosSelecionados: DialogoDePagamentoEmMassaDeTitulos['titulosFormatados'] = []
	titulos: Titulo[] = []
	titulosCache: Record<string, Titulo> = {}
	totalRegistros = -1
	pdvOptions: PontoDeVendaComTurno[] = []
	data = ''
	todosForamSelecionados = false
	salvando = false
	idsDeTitulosSelecionados: string[] = []
	valorJurosSobreBaixa: number | null = null
	valorDaMultaSobreBaixa: number | null = null
	valorFaltanteDoTitulo: number | null = null
	valorTotalTitulo: number | null = null
	valorFaltante: number | null = null
	valoresPorTitulo: Record<string, ValorSomaTitulo> = {}
	tipoDePessoa: 'cliente' | 'adquirente' = 'cliente'
	clienteAdquirente: string | null = null
	titulosFiltradoDaTelaPrincipal = false

	findTituloUseCase = new FindTituloUseCase()
	createBaixaUseCase = new CreateBaixaDePagamentoUseCase()
	findPdvUseCase = new FindPdvUseCase()
	findBaixaDePagamentoUseCase = new FindBaixaDePagamentoUseCase()

	obrigatorio = obrigatorio
	formatarMoeda = formatarMoeda

	paginacao: DataOptions = {
		page: 0,
		itemsPerPage: 50,
		sortBy: [],
		sortDesc: [],
		groupBy: [],
		groupDesc: [],
		multiSort: false,
		mustSort: false,
	}

	tipoDeDesconto: 'valorFixo' | 'porcentagem' = 'valorFixo'
	baixaDePagamento: BaixaDePagamentoMultiploForm = {
		titulo: null,
		transactionId: '',
		valorPagamento: 0,
		valorTaxa: 0,
		dataHoraPagamento: '',
		isTaxa: false,
		isIntegracao: false,
		formaDePagamento: null,
		turnoDeVendaId: null,
		valorJurosSobreBaixa: 0,
		valorDaMultaSobreBaixa: 0,
		tipoDeTransacao: null,
		valorDeDescontoNosJuros: 0,
		valorDeDescontoNaMulta: 0,
		tipoDeDesconto: this.tipoDeDesconto,
	}


	filtros: FormDeFiltroDeTitulos = this.obterFiltrosDeTitulosIniciais()
	
	headers = [
		{ text: 'Loja', value: 'loja', width: '18%' },
		{ text: 'Série', value: 'serie', width: '2%' },
		{ text: 'Número', value: 'numero', width: '2%' },
		{ text: 'Parcela', value: 'sequencia', width: '2%' },
		{ text: 'Descrição', value: 'descricao', width: '20%' },
		{ text: 'Competência', value: 'dataDeCompetencia', width: '10%' },
		{ text: 'Vencimento', value: 'dataDeVencimento', width: '10%' },
		{ text: 'Data Pagamento', value: 'dataPagamento', width: '10%' },
		{ text: 'Cliente', value: 'pessoa', width: '20%' },
		{ text: 'Valor', value: 'valor', width: '12%', align: 'right' },
		{ text: 'Valor Atualizado', value: 'valorAtualizado', width: '12%', sortable: false,  align: 'right' },
		{ text: 'Juros e Multa', value: 'totalEncargos', width: '10%', sortable: false,  align: 'right' },
		{ text: 'Forma de pagamento', value: 'formaDePagamento', width: '8%' },
	]

	opcoesDeFormaDePagamentoParaBusca: FormaDePagamento[] = [
		'Dinheiro',
		'Cartão',
		'Voucher',
		'Crediário',
		'TEF Crédito',
		'TEF Débito',
		'TEF Pix',
		'Link',
		'Outros',
		'Cheque',
		'Pix',
		'Boleto',
	]

	opcoesDeFormaDePagamento: FormaDePagamento[] = [
		'Dinheiro',
		'Cartão',
		'Pix',
		'Cheque',
		'Permuta',
	]

	calcularValorFaltante(titulo: Titulo): Titulo {
		if (
			titulo.formaDePagamento === "CREDIARIO" &&
			titulo.fluxo === 'Entrada' && 
			this.carregando === false
		) {
			const calcularJurosComMulta = titulo.loja?.configuracaoDaLoja?.calcularJurosComMulta || false
			const horaFormatada = new Date().toLocaleTimeString('pt-BR')
			const data = new Date(`${this.data}T${horaFormatada}`)
			const dataStr = titulo.dataDeVencimento
			const [ano, mes, dia] = dataStr.split('-').map(Number)
			const dataDeVencimento = new Date(ano, mes - 1, dia)
			const dataAposCarencia = calcularDataAposCarencia(titulo, dataDeVencimento)

			const dataPagamentoSemHora = new Date(this.data + 'T00:00:00')
			const diferencaMsVencimento = dataPagamentoSemHora.getTime() - dataDeVencimento.getTime()
			const dias = Math.max(0, Math.floor(diferencaMsVencimento / (1000 * 60 * 60 * 24)))

			const taxa = new Decimal(titulo.porcentagemDeJuros || 0).div(100)
			const expoente = new Decimal(dias)
			const dataPagamento = new Date(data)
			const dataAposCarenciaSemHora = new Date(dataAposCarencia)

			dataPagamento.setHours(0, 0, 0, 0)
			dataAposCarenciaSemHora.setHours(0, 0, 0, 0)

			this.valoresPorTitulo[titulo.id] = {
				id: titulo.id,
				somaValorPagamentoBaixasExistentes: titulo.baixaDePagamentoAuditada.reduce(
					(soma, baixa) => soma + Number(baixa.valorPagamento || 0), 0,
				),
				somaValorPagamentoJurosExistentes: titulo.baixaDePagamentoAuditada.reduce(
					(soma, baixa) => soma + Number(baixa.valorJurosSobreBaixa || 0), 0,
				),
				somaValorPagamentoMultaExistentes: titulo.baixaDePagamentoAuditada.reduce(
					(soma, baixa) => soma + Number(baixa.valorDaMultaSobreBaixa || 0), 0,
				),
				somaValorDescontosExistentes: titulo.baixaDePagamentoAuditada.reduce(
					(soma, baixa) => soma + Number(baixa.valorDesconto || 0), 0,
				),
			};

			const somaBaixas = this.valoresPorTitulo[titulo.id]?.somaValorPagamentoBaixasExistentes || 0
			const somaPagamentoMulta = this.valoresPorTitulo[titulo.id]?.somaValorPagamentoMultaExistentes || 0
			const somaDescontos = this.valoresPorTitulo[titulo.id]?.somaValorDescontosExistentes || 0

			const valorTituloRestante = new Decimal(titulo.valor)
				.sub(somaBaixas)
				.sub(somaDescontos)

			let valorMulta = new Decimal(titulo.multa || 0)
			if (somaPagamentoMulta === 0 && Number(valorMulta) === 0 && titulo.porcentagemDeMulta !== null && titulo.porcentagemDeMulta > 0) {
				valorMulta = new Decimal(titulo.valor).mul(new Decimal(titulo.porcentagemDeMulta).div(100))
			}

			if (titulo.jurosComposto) {

				const capitalParaJuros = calcularJurosComMulta
					? valorTituloRestante.add(valorMulta)
					: valorTituloRestante

				const montanteFinal = capitalParaJuros.mul(
					Decimal.pow(new Decimal(1).add(taxa), expoente),
				)

				const jurosCalculados = Math.max(montanteFinal.minus(capitalParaJuros).toNumber(), 0)

				const jurosRecalculado = Number(jurosCalculados.toFixed(2))
				titulo.jurosRecalculado = dataPagamento <= dataAposCarenciaSemHora ? 0 : Math.max(0, jurosRecalculado)

				const multaRecalculada = dataPagamento <= dataAposCarenciaSemHora
					? 0
					: Number(valorMulta.toFixed(2)) - somaPagamentoMulta
				titulo.multaRecalculado = Math.max(0, multaRecalculada)

			} else {
				const capitalParaJuros = calcularJurosComMulta
					? valorTituloRestante.add(valorMulta)
					: valorTituloRestante

				const montanteFinal = capitalParaJuros.mul(taxa.mul(dias).add(1))
				const jurosCalculados = Math.max(montanteFinal.minus(capitalParaJuros).toNumber(), 0)

				const jurosRecalculado = Number(jurosCalculados.toFixed(2))
				titulo.jurosRecalculado = dataPagamento <= dataAposCarenciaSemHora ? 0 : Math.max(0, jurosRecalculado)

				const multaRecalculada = dataPagamento <= dataAposCarenciaSemHora
					? 0
					: Number(valorMulta.toFixed(2)) - somaPagamentoMulta
				titulo.multaRecalculado = Math.max(0, multaRecalculada)
			}

			titulo.valorRecalculado = Math.max(0, valorTituloRestante.toNumber())
				+ titulo.jurosRecalculado
				+ titulo.multaRecalculado

			return titulo
		}else{
			titulo.valorRecalculado = titulo.valorAtualizado
		}

		return titulo
	}

	isDataDePagamentoValida() {
		const listaDeTitulosInvalidos: string[] = []
		this.titulosSelecionados.forEach(titulo => {
			if (!this.ehDataValidaParaLiberacao(this.data, titulo)) {
				listaDeTitulosInvalidos.push(`${titulo.numero}/${titulo.sequencia}`)
			}
		})

		if(listaDeTitulosInvalidos.length > 0 ) {
			return `Data de pagamento inválida para os títulos selecionados`
		}

		return true
	}

	ehDataValidaParaLiberacao(data: string, titulo: any) {
		if (!data || !titulo?.dataDeCompetencia) return false;

		const dataSelecionada = moment(data).format('YYYY-MM-DD')
		const dataDeCompetencia = moment(titulo.dataDeCompetencia, 'DD/MM/YYYY').format('YYYY-MM-DD')
		
		return dataSelecionada < dataDeCompetencia ?
			false : true
	}

	@Watch('data')
	setDataPagamentoNosTitulos() {
		if (!this.data) return

		if (new Date(this.data).getTime() > Date.now()) {
			this.data = new Date().toISOString().substring(0, 10);
			AlertModule.setError('A data não pode ser maior que a data atual');
			return;
		}

		this.titulosSelecionados = this.titulosSelecionados.map(tituloSelecionado => {
			const tituloOriginal = this.titulos.find(t => t.id === tituloSelecionado.id)
			if (!tituloOriginal) return tituloSelecionado

			const tituloAtualizado = this.calcularValorFaltante(tituloOriginal)

			return {
				...tituloSelecionado,
				dataPagamento: this.data,
				valorAtualizado: tituloAtualizado.valorRecalculado?.toLocaleString('pt-br', {
					style: 'currency',
					currency: 'BRL',
				}) || '',
				juros: tituloAtualizado.jurosRecalculado?.toLocaleString('pt-br', {
					style: 'currency',
					currency: 'BRL',
				}) || '',
				multa: tituloAtualizado.multaRecalculado?.toLocaleString('pt-br', {
					style: 'currency',
					currency: 'BRL',
				}) || '',
			}
		})
	}

	@Watch('titulosFormatados', { deep: true })
	atualizarOsTitulosSelecionados() {

		this.titulosSelecionados.forEach(tituloSelecionado => {
			const titulo = this.titulosFormatados.find(titulo => titulo.id === tituloSelecionado.id)
			if (titulo) {
				tituloSelecionado.valorAtualizado = titulo.valorAtualizado
				tituloSelecionado.juros = titulo.juros
				tituloSelecionado.multa = titulo.multa
			}
		})
	}


	mostrar(titulos: Titulo[] = []) {
		this.filtros = JSON.parse(localStorage[FILTRO_DE_TITULOS] ?? 'null')
		this.data = moment().tz('America/Sao_Paulo').format('YYYY-MM-DD');
		this.mostra = true
		this.lojaId = this.filtros.loja
		this.formaDePagamento = this.filtros.formaDePagamento || ''
		this.usuario = this.filtros.pessoa	
		if(titulos){
			this.titulos = titulos
			this.titulosFiltradoDaTelaPrincipal = true
			titulos.forEach(titulo => { this.titulosCache[titulo.id] = titulo })
			this.$nextTick(() => {
				this.selecionarVencidos()
			})
		}
	}

	esconder() {
		this.mostra = false
		this.salvando = false
		this.lojaId = null
		this.usuario = null
		this.valor = null
		this.formattedValue = null
		this.valorAtualizado = null
		this.formaDePagamento = ''
		this.formaDePagamamentoParaPagar = null
		this.titulos = []
		this.titulosCache = {}
		this.totalRegistros = -1
		this.pdvOptions = []
		this.data = ''
		this.baixaDePagamento = {
			titulo: null,
			transactionId: '',
			valorPagamento: 0,
			valorTaxa: 0,
			dataHoraPagamento: '',
			isTaxa: false,
			isIntegracao: false,
			formaDePagamento: null,
			turnoDeVendaId: null,
			valorJurosSobreBaixa: 0,
			valorDaMultaSobreBaixa: 0,
			tipoDeTransacao: null,
			valorDeDescontoNosJuros: 0,
			valorDeDescontoNaMulta: 0,
			tipoDeDesconto: this.tipoDeDesconto,
		}
		this.limparFiltros()
		this.limparSelecao()
	}

	limparFiltros() {
		this.lojaId = null;
		this.formaDePagamento = ''
		this.usuario = null;
		this.formaDePagamamentoParaPagar = null;
		this.valor = null;
		this.titulosSelecionados = [];
		this.limparSelecao()
	}

	displayPagamento(formaDePagamento: string) {
		let formaFormatada
		if (formaDePagamento == 'CARTAO') formaFormatada = 'Cartão'
		if (formaDePagamento == 'DINHEIRO') formaFormatada = 'Dinheiro'
		if (formaDePagamento == 'VOUCHER') formaFormatada = 'Voucher'
		if (formaDePagamento == 'OUTROS') formaFormatada = 'Outros'
		if (formaDePagamento == 'TEF CREDITO') formaFormatada = 'TEF Crédito'
		if (formaDePagamento == 'TEF DEBITO') formaFormatada = 'TEF Débito'
		if (formaDePagamento == 'CREDIARIO') formaFormatada = 'Crediário'
		if (formaDePagamento == 'LINK') formaFormatada = 'Link'
		if (formaDePagamento == 'CHEQUE') formaFormatada = 'Cheque'
		if (formaDePagamento == 'PIX') formaFormatada = 'Pix'
		if (formaDePagamento == 'BOLETO') formaFormatada = 'Boleto'
		if (formaDePagamento == 'PERMUTA') formaFormatada = 'Permuta'
		return formaFormatada
	}

	
	obterFiltrosDeTitulosIniciais(): FormDeFiltroDeTitulos {
		return {
			pessoa: null,
			tipoDeCliente: null,
			dataInicioPeriodo: null,
			dataFimPeriodo: null,
			situacaoDoTitulo: null,
			formaDePagamento: null,
			loja: null,
			numeroDocumento: null,
			dataInicioPagamento: null,
			dataFimPagamento: null,
			fluxo: null,
			numeroDoCheque: null,
			clienteAdquirente: null,
			somenteComValorDesatualizado: false,
			somenteComErroDeRecalculo: false,
		}
	}

	onPdvChange(selectedPdvId) {
		this.baixaDePagamento.turnoDeVendaId = selectedPdvId;
	}

	desformatarTitulo(tituloFormatado) {
		return {
			id: tituloFormatado.id,
			descricao: tituloFormatado.descricaoCompleta || '', 
			valor: formatarMoeda(tituloFormatado.valor)|| 0,
			valorAtualizado: parseFloat(tituloFormatado.valorAtualizado.replace(/[^0-9,-]+/g, "").replace(",", ".")) || 0,
			juros: parseFloat(tituloFormatado.juros.replace(/[^0-9,-]+/g, "").replace(",", ".")) || 0,
			multa: parseFloat(tituloFormatado.multa.replace(/[^0-9,-]+/g, "").replace(",", ".")) || 0,
			dataDeVencimento: new Date(tituloFormatado.dataDeVencimento.split('/').reverse().join('-')),
			dataPagamento: tituloFormatado.dataPagamento ? new Date(tituloFormatado.dataPagamento.split('/').reverse().join('-')) : null,
			situacao: tituloFormatado.situacao || '',
			pessoa: tituloFormatado.pessoa || '', 
			loja: tituloFormatado.loja || '', 
			formaDePagamento: tituloFormatado.formaDePagamento || '',
			serie: tituloFormatado.serie || '', 
			numero: tituloFormatado.numero || '',
			sequencia: tituloFormatado.sequencia || '',
			temParcelamento: tituloFormatado.temParcelamento || false,
			tipoDePagamento: tituloFormatado.tipoDePagamento || '', 
			baixaPagamento: tituloFormatado.baixaPagamento || '', 
			dataDeCompetencia: tituloFormatado.dataDeCompetencia || new Date(), 
			fluxo: tituloFormatado.fluxo || '', 
		}
	}

	preencherPdvAutomatico() {
		const turnoDeVenda = JSON.parse(localStorage.getItem('TURNO_DE_VENDA_STORAGE') || 'null');

		if (turnoDeVenda && turnoDeVenda.pontoDeVenda) {
			const pdv = {
				turnoDeVendaId: turnoDeVenda.id,
				nomePontoDeVenda: turnoDeVenda.pontoDeVenda.nome,
			};

			if (!this.pdvOptions.some(p => p.turnoDeVendaId === pdv.turnoDeVendaId)) {
				this.pdvOptions = [pdv, ...this.pdvOptions];
			}

			if (!this.baixaDePagamento.turnoDeVendaId) {
				this.baixaDePagamento.turnoDeVendaId = pdv.turnoDeVendaId;
			}
		}
	}


	async buscarPdvAberto() {			
		if (!this.titulos || this.titulos.length === 0 || !this.titulos[0].loja) return;
		const lojaId = this.titulos[0].loja.id;
		const pdvs = await this.findPdvUseCase.buscarPdvSemTurno(lojaId);
		this.pdvOptions = [...this.pdvOptions, ...pdvs];
	}

	valorMenorQueTotal(v) {
		if (!v) return 'Valor de pagamento é obrigatório'

		const total = parseFloat(this.totalSelecionado.replace(/\./g, '').replace(',', '.'))
		const valor = parseFloat(v.toString().replace(/\./g, '').replace(',', '.'))
		const isValid = (total !== null && valor <= total) || 'Valor de pagamento não pode ser maior que o valor sugerido'
		return isValid
	}

	get permitirAlterarDataBaixa() {
		return UserLoginStore.permiteRegraDeNegocio('permitir-alteracao-data-pagamento')
	}

	get totalSelecionado() {
		return formatarMoeda(Number.parseFloat(this.titulosSelecionados.reduce((total, titulo) => {
			let valor = parseFloat(titulo.valorAtualizado.replace(/[^\d,-]/g, '').replace(',', '.'))
			if (isNaN(valor)) {
				valor = 0
			}
			return total + valor
		}, 0).toFixed(2)))
	}

	get totalSelecionadoSemJuros() {
		return formatarMoeda(Number.parseFloat(this.titulosSelecionados.reduce((total, titulo) => {
			let valor = parseFloat(titulo.valor.replace(/[^\d,-]/g, '').replace(',', '.'));
			if (isNaN(valor)) {
				valor = 0;
			}
			return total + valor;
		}, 0).toFixed(2)));
	}

	limparSelecao() {
		this.titulosSelecionados = []
		this.todosForamSelecionados = false
		this.idsDeTitulosSelecionados = []
	}

	selecionarTodos() {
		this.titulosSelecionados = this.titulosFormatados
		this.todosForamSelecionados = true
	}

	selecionarVencidos() {
		const hoje = moment().tz('America/Sao_Paulo').format('YYYY-MM-DD')
		const idsVencidos = new Set(
			this.titulos
				.filter(t => t.dataDeVencimento && t.dataDeVencimento <= hoje)
				.map(t => t.id),
		)
		this.titulosSelecionados = this.titulosFormatados.filter(t => idsVencidos.has(t.id))
		this.todosForamSelecionados = false
	}

	get titulosFormatados() {
		return this.titulos.map(titulo => {
			const maxDescriptionLength = 18
			let descricao = titulo.descricao || ''
			const descricaoCompleta = descricao

			if (descricao.length > maxDescriptionLength) {
				const truncated = descricao.substring(0, maxDescriptionLength);
				const lastSpaceIndex = truncated.lastIndexOf(' ');
				if (lastSpaceIndex > 0) {
					descricao = truncated.substring(0, lastSpaceIndex) + '...';
				} else {
					descricao = truncated + '...';
				}
			}

			const tituloComValorAtualizado = this.calcularValorFaltante(titulo)
			const totalEncargos = (tituloComValorAtualizado.jurosRecalculado || 0) + (tituloComValorAtualizado.multaRecalculado || 0);
			return {
				...tituloComValorAtualizado,
				dataDeVencimento: dateToPtBrFormat(tituloComValorAtualizado.dataDeVencimento),
				dataDeCompetencia: dateToPtBrFormat(tituloComValorAtualizado.dataDeCompetencia),
				descricaoCompleta,
				dataPagamento: tituloComValorAtualizado.baixaPagamento ? dateToPtBrFormat(tituloComValorAtualizado.baixaPagamento) : null,
				valor: titulo.valor?.toLocaleString('pt-br', {
					style: 'currency',
					currency: 'BRL',
				}) || '',
				pessoa: titulo.pessoa?.razaoSocialOuNome || '',
				loja: titulo.loja?.nomeFantasia || '',
				formaDePagamento: titulo.formaDePagamento
					? this.displayPagamento(titulo.formaDePagamento)
					: '',
				valorAtualizado: titulo.valorRecalculado?.toLocaleString('pt-br', {
					style: 'currency',
					currency: 'BRL',
				}) || '',
				juros: titulo.jurosRecalculado?.toLocaleString('pt-br', {
					style: 'currency',
					currency: 'BRL',
				}) || '',
				multa: titulo.multaRecalculado?.toLocaleString('pt-br', {
					style: 'currency',
					currency: 'BRL',
				}) || '',
				totalEncargos: totalEncargos.toLocaleString('pt-br', {
					style: 'currency',
					currency: 'BRL',
				}) || '',
				descricao: descricao,
			}

		})
	}

	get tokenDoUsuario() {
		return UserLoginStore.token
	}
	@Watch('lojaId')
	onLojaIdChange() {
		this.buscar();
	}

	@Watch('usuario')
	onUsuarioChange() {
		this.buscar();
	}

	@Watch('formaDePagamento')
	onFormaDePagamentoChange() {
		this.buscar();
	}

	@Watch('titulosSelecionados')
	onTitulosSelecionadosChange() {
		this.preencherPdvAutomatico();
		this.buscarPdvAberto()
		this.idsDeTitulosSelecionados = this.titulosSelecionados
			.map(titulo => titulo.id)
			.filter(id => !this.idsDeTitulosSelecionados.includes(id))
			.concat(this.idsDeTitulosSelecionados);
	}

	@Watch('paginacao')
	async buscar() {
		try {
			if(!this.usuario?.id && !this.clienteAdquirente) return
			if(!this.lojaId) return
			this.carregando = true;

			if(this.titulos.length > 0 && this.titulosFiltradoDaTelaPrincipal) {
				await Promise.all(this.titulos.map(async titulo => {
					const params = {
						tituloId: titulo.id,
					}

					const baixasDoTitulo = await this.findBaixaDePagamentoUseCase.findByTituloId(
						params,
					)

					titulo.baixaDePagamentoAuditada = baixasDoTitulo.content
				}))
				
				
				this.titulos = this.titulos.filter(titulo => {
					const totalBaixas = titulo.baixaDePagamentoAuditada?.reduce((total, baixa) =>
						total + Number((baixa.valorPagamento - baixa.valorDesconto) || 0), 0) || 0;
					return totalBaixas < titulo.valor;
				});
				this.titulos.forEach(titulo => { this.titulosCache[titulo.id] = titulo })
				
				this.totalRegistros = this.titulos.length

				await this.$nextTick()
				this.atualizarTitulosSelecionados(this.titulosSelecionados)
				this.titulosFiltradoDaTelaPrincipal = false
				return
			}
			
			this.limparSelecao()
			const isTodos = this.paginacao.itemsPerPage === -1
			const size = isTodos
				? (this.totalRegistros > 0 ? this.totalRegistros : 99999)
				: this.paginacao.itemsPerPage

			const page = await this.findTituloUseCase.findParaBaixa({
				lojaId: this.lojaId,
				clienteId: this.usuario?.id,
				formaDePagamento: this.formaDePagamento,
				clienteAdquirente: this.clienteAdquirente,
				page: isTodos ? 0 : this.paginacao.page - 1,
				size,
			})

			await Promise.all(page.content.map(async titulo => {
				const params = {
					tituloId: titulo.id,
				}

				const baixasDoTitulo = await this.findBaixaDePagamentoUseCase.findByTituloId(
					params,
				)

				titulo.baixaDePagamentoAuditada = baixasDoTitulo.content
			}))


			this.titulos = page.content.filter(titulo => {
				const totalBaixas = titulo.baixaDePagamentoAuditada?.reduce((total, baixa) =>
					total + Number((baixa.valorPagamento - baixa.valorDesconto) || 0), 0) || 0;
				return totalBaixas < titulo.valor;
			});
			this.titulos.forEach(titulo => { this.titulosCache[titulo.id] = titulo })

			this.totalRegistros = page.totalElements

			await this.$nextTick()
			this.atualizarTitulosSelecionados(this.titulosSelecionados)
		} catch (e) {
			AlertModule.setError(e)
			this.carregando = false;
		} finally {
			this.carregando = false;
		}
	}

	atualizarTitulosSelecionados(titulosSelecionadosAnteriores: any[]) {
		const titulosAnteriores = titulosSelecionadosAnteriores.filter(titulo => 
			this.idsDeTitulosSelecionados.includes(titulo.id) && 
			!this.titulos.some(t => t.id === titulo.id),
		);
		
		const titulosNovosParaSelecionar = this.titulosFormatados.filter(titulo => 
			this.idsDeTitulosSelecionados.includes(titulo.id),
		);
		
		this.titulosSelecionados = [...titulosAnteriores, ...titulosNovosParaSelecionar];
	}

	async salvar() {
		if (!this.form.validate()) return
		if (!this.baixaDePagamento) return

		try {
			this.salvando = true
			const titulosSelecionadosOriginais = this.titulosSelecionados.map(selecionado => {
				const titulo = this.titulosCache[selecionado.id]
				if (!titulo) {
					throw new Error(`Titulo com ID ${selecionado.id} não encontrado.`)
				}

				const tituloAtualizado = this.calcularValorFaltante(titulo)
				
				return {
					...titulo,
					juros: tituloAtualizado.jurosRecalculado,
					multa: tituloAtualizado.multaRecalculado,
					valorAtualizado: tituloAtualizado.valorRecalculado,
					recalculado: true,
				}
			})

			this.baixaDePagamento.titulo = titulosSelecionadosOriginais;
			this.baixaDePagamento.valorPagamento = !this.valor ? 0 : this.valor
			this.baixaDePagamento.formaDePagamento = this.formaDePagamamentoParaPagar
			this.baixaDePagamento.transactionId = ''
			this.baixaDePagamento.tipoDeTransacao = TipoDeTransacaoDaBaixaDePagamento.BAIXA
			const horaFormatada = new Date().toLocaleTimeString('pt-BR')
			this.baixaDePagamento.dataHoraPagamento = `${this.data}T${horaFormatada}`
			const comprovanteDasBaixas = await this.createBaixaUseCase.createMultiplo(this.baixaDePagamento)
			await imprimirComprovanteDeRecebivel(comprovanteDasBaixas)
			this.$emit('atualizar')
			this.esconder()
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.salvando = false
			this.mostra = false
		}
	}

	gerarDataHora(data?: string | null, hora?: string | null): string {
		const dateTimeString = `${data}T${hora}:00`;
		const localDateTime = moment(dateTimeString, 'YYYY-MM-DDTHH:mm:ss');
		const utcDateTime = localDateTime.utcOffset(0, true); // Define o offset para 0 (UTC)
		const utcDateTimeString = utcDateTime.toISOString();

		return utcDateTimeString;
	}

	formatarNumero(numero) {
		const numeroFormatado = numero.toLocaleString('pt-BR', {
			style: 'currency',
			currency: 'BRL',
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		});
		return numeroFormatado;
	}

	get podeBaixarSelecionados(){
		return UserLoginStore.permiteRegraDeNegocio('pode-baixar-selecionados-contas-a-receber')
	}

	get podeBaixarMultiplas(){
		return UserLoginStore.permiteRegraDeNegocio('pode-baixar-multiplas-contas-a-receber')
	}

	@Watch('tipoDePessoa')
	onTipoDePessoaChange() {
		if (this.tipoDePessoa === 'adquirente'){
			this.usuario = null
		} else {
			this.clienteAdquirente = null
		}

		this.buscar()
	}

	@Watch('clienteAdquirente')
	onClienteAdquirenteChange() {
		this.buscar();
	}

}
